import dynamic from 'next/dynamic';
import { RateCardProps } from './RateCard.types';
import { RateCardLoader } from './RateCardLoader';

export const RateCardMGP = dynamic<RateCardProps>(() => import('./RateCard').then(module => module.RateCard), {
  loading: () => <RateCardLoader />,
});
